import { Link, Box, Button, FormControl, Grid, SvgIcon, TextField, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PageTitle from '../../../components/shared/PageTitle';
import CustomBreadCrumbs from '../../../components/ui/CustomBreadCrumbs';
import { useContext } from 'react';
import { WasteChecksheetDetailContext, WasteChecksheetDetailValues } from '../contexts/WasteChecksheetDetailContext';
import { Printer, Save01, Minus, FileCheck03 } from '../../../assets';
import { formatDateHourString } from '../../../utils';

const WasteCheckSheetTitleArea = () => {
  const { t,
    isMobile,
    isArchived,
    hasPermissionToWrite,
    submittedBy,
    submittedDate,
    isLoading,
    itemsByCategory,
  } = useContext(WasteChecksheetDetailContext) as WasteChecksheetDetailValues;

  return <>
    <Box>
      <CustomBreadCrumbs title={t('details.title')}>
        <Link to="/store/waste-checksheets"
          component={RouterLink}>Waste</Link>
      </CustomBreadCrumbs>
    </Box>
    <Box sx={{ minHeight: '56px' }}>
      <Stack width='100%'
        spacing={2}
        direction={isMobile ? 'column' : 'row'}
        sx={{
          justifyContent: 'space-between',
        }}>
        <Box width={isMobile ? '100%' : 'auto'}>
          <PageTitle>{t('details.title')}</PageTitle>
        </Box>
        {!isArchived && hasPermissionToWrite && !isLoading && itemsByCategory.length > 0 &&
          !isMobile && <DesktopButtons />}
      </Stack>
      {!isArchived && hasPermissionToWrite && !isLoading && itemsByCategory.length > 0 &&
        isMobile && <MobileButtons />}
      {isArchived && !isLoading && itemsByCategory.length > 0 && <Grid container
        sx={{ pb: '12px', pt: '4px' }}
        spacing={4}>
        <Grid item
          xs={6}
          sm={6}
          lg={3}>
          <FormControl fullWidth>
            <TextField
              label={t('list.submittedDate')}
              id="waste-date"
              disabled
              value={formatDateHourString(submittedDate!)}
              InputLabelProps={{ shrink: true }} />
          </FormControl>
        </Grid>
        <Grid item
          xs={6}
          sm={6}
          lg={3}>
          <FormControl fullWidth>
            <TextField
              label={t('list.submittedBy')}
              id="waste-submitted-by"
              disabled
              value={submittedBy}
              InputLabelProps={{ shrink: true }} />
          </FormControl>
        </Grid>
      </Grid>}
    </Box>
  </>;
};

const DesktopButtons = () => {
  const { t,
    printTableContainer,
    hasPermissionToWrite,
    handleSaveConfirmModal,
    isSaveSubmitEnabled,
    handleReset,
    handleSubmitButton,
  } = useContext(WasteChecksheetDetailContext) as WasteChecksheetDetailValues;

  return <Stack spacing={5}
    direction={'row'}
    sx={{ pb: '12px' }}>
    <Button
      variant="secondary"
      size="lg"
      startIcon={<SvgIcon><Printer /></SvgIcon>}
      onClick={printTableContainer}>
      {t('printChecksheetBtn')}
    </Button>
    {hasPermissionToWrite && <>
      <Button
        variant="badSecondary"
        size="lg"
        startIcon={<SvgIcon><Minus /></SvgIcon>}
        onClick={handleReset}>
        {t('resetBtn')}
      </Button>
      <Button
        variant="primary"
        size="lg"
        startIcon={<SvgIcon><Save01 /></SvgIcon>}
        onClick={handleSaveConfirmModal}
        disabled={!isSaveSubmitEnabled()}>
        {t('saveBtn')}
      </Button>
      <Button variant="primary"
        size="lg"
        type='submit'
        startIcon={<SvgIcon><FileCheck03 /></SvgIcon>}
        disabled={!isSaveSubmitEnabled}
        onClick={handleSubmitButton}>
        {t('submitBtn')}
      </Button>
    </>}
  </Stack>;
};

const MobileButtons = () => {
  const { t,
    printTableContainer,
    hasPermissionToWrite,
    handleSaveConfirmModal,
    isSaveSubmitEnabled,
    handleReset,
    handleSubmitButton,
  } = useContext(WasteChecksheetDetailContext) as WasteChecksheetDetailValues;

  return <Grid container
    sx={{ pb: '12px' }}
    spacing={4}>
    <Grid item
      xs={6}
      sm={3}
      lg={2}>
      <Button
        variant="secondary"
        size="lg"
        startIcon={<SvgIcon><Printer /></SvgIcon>}
        onClick={printTableContainer}
        fullWidth>
        {t('printChecksheetBtn')}
      </Button>
    </Grid>
    {hasPermissionToWrite && <>
      <Grid item
        xs={6}
        sm={3}
        lg={2}>
        <Button
          variant="badSecondary"
          size="lg"
          startIcon={<SvgIcon><Minus /></SvgIcon>}
          fullWidth
          onClick={handleReset}
        >
          {t('resetBtn')}
        </Button>
      </Grid>
      <Grid item
        xs={6}
        sm={3}
        lg={2}>
        <Button
          variant="primary"
          size="lg"
          startIcon={<SvgIcon><Save01 /></SvgIcon>}
          onClick={handleSaveConfirmModal}
          disabled={!isSaveSubmitEnabled()}
          fullWidth
        >
          {t('saveBtn')}
        </Button>
      </Grid>
      <Grid item
        xs={6}
        sm={3}
        lg={2}>
        <Button fullWidth
          variant="primary"
          size="lg"
          type='submit'
          startIcon={<SvgIcon><FileCheck03 /></SvgIcon>}
          disabled={!isSaveSubmitEnabled}
          onClick={handleSubmitButton}
        >
          {t('submitBtn')}
        </Button>
      </Grid>
    </>}
  </Grid>;
};

export default WasteCheckSheetTitleArea;